import { gsap } from 'gsap';

const HOVER_DELAY = 100;

const initPageAccordion = () => {
	const nav = document.querySelector('[data-page-accordion]');
	if (!nav) return;

	const items = nav.querySelectorAll('[data-panel-item] a');
	if (!items.length) return;

	let activeItem = null;
	let closeTween = null;
	let openTween = null;
	let hoverTimer = null;

	const closePanel = (item) => {
		const panel = item;
		if (!panel) return;
		if (closeTween) closeTween.kill();
		closeTween = gsap.to(panel, {
			height: 85,
			duration: 0.35,
			ease: 'power2.inOut',
			onStart: () => {
				panel.setAttribute('aria-hidden', 'true');
			},
		});
	};

	const openPanel = (item) => {
		const panel = item;
		if (!panel) return;

		if (activeItem === item) return;

		if (activeItem) {
			closePanel(activeItem);
		}
		activeItem = item;
		panel.setAttribute('aria-hidden', 'false');
		if (openTween) openTween.kill();

		openTween = gsap.to(panel, {
			height: 120,
			duration: 0.45,
			ease: 'power2.inOut',
		});
	};

	const handleTriggerEnter = (item) => {
		clearTimeout(hoverTimer);
		hoverTimer = setTimeout(() => openPanel(item), HOVER_DELAY);
	};

	const handleTriggerLeave = (item) => {
		closePanel(item);
		activeItem = null;
		clearTimeout(hoverTimer);
	};

	const handleTriggerFocus = (item) => {
		console.log('handleTriggerFocus');
		openPanel(item);
	};

	items.forEach((item, index) => {
		const panel = item.querySelector('[data-panel-panel]');

		if (panel) {
			gsap.set(panel, { height: 0 });
		}

		if (index === 0 && panel) {
			openPanel(item);
		}

		if (item) {
			item.addEventListener('mouseenter', () => handleTriggerEnter(item));
			item.addEventListener('mouseleave', () => handleTriggerLeave(item));
			item.addEventListener('focus', () => handleTriggerFocus(item));
		}
	});

	// nav.addEventListener('mouseleave', handleNavLeave);
};

export { initPageAccordion };
